// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22dea","title":"Header_title__CahGm","side":"Header_side__1Zp4E"};